export default __webpack_public_path__ + "static/media/mobile_cardcustom2.39faa826.webp";